import styled, { css } from "styled-components";
import { Spin as SpinAntd } from "antd";

export const Container = styled.div`
  height: 100%;
`;

export const HeaderPage = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;

  svg {
    width: 18px;
    height: 18px;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.primary};
  }

  > div {
    padding-left: 0;
  }

  @media (min-width: 768px) {
    padding: 0 2rem;
  }
`;

export const Spin = styled(SpinAntd)`
  margin: 0 auto;
  width: 100%;
  color: ${({ theme }) => theme.colors.primary} !important;
  font-size: 1rem;
  margin-top: 1rem;

  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }
`;

export const Managements = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    @media (min-width: 768px) {
      max-height: calc(100% - 110px);
      width: 380px;
      overflow-y: auto;
    }
  `}
`;

export const ActionsManagement = styled.div`
  ${({ theme }) => css`
    display: flex;

    svg + svg {
      margin-left: 1rem;
    }
  `}
`;

export const Filter = styled.div`
  display: flex;
  padding: 1rem 0 1rem 1rem;

  > input {
    padding: 0 0.5rem;
    width: 160px;
    border-radius: 8px;
    border: 1px solid #000;
    margin-right: 1rem;
  }

  > span {
    margin-right: 1rem;
  }
`;

export const ContentManagement = styled.div`
  padding: 1rem;
`;

export const DateFiltered = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: ${theme.colors.ultraLightGray};

    p {
      text-transform: capitalize;
      margin: 0;
      color: ${theme.colors.primary};
    }

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
    }
  `}
`;
